import { inject, Injectable } from '@angular/core';
import { CanMatch, Router, UrlTree } from '@angular/router';
import { ShoppingCartState } from '../../../shared/states/shopping-cart-state';

@Injectable({
  providedIn: 'root',
})
export class PurchaseCompletionGuardService implements CanMatch {
  private shoppingCartState = inject(ShoppingCartState);
  router = inject(Router);

  canMatch(): boolean | UrlTree {
    const count = this.shoppingCartState.shoppingCartItemsCount();
    return count > 0 ? true : this.router.createUrlTree(['/']);
  }
}
